module.exports = __webpack_public_path__ + "static/img/balance.63452beb.svg";